<template>
  <div class="panel" id="panel">
    <div class="header">
      <div class="avatar">
        <img :src="iconUrl(userInfo.headImage)" />
      </div>
      <div class="info">
        <div class="nickName">
          <span>{{userInfo.name}}</span>
        </div>
      </div>
      <p class="exit" @click="exit()">退出</p>
    </div>
    <div class="chat_list">
      <div class="chat_item" v-for="item in conversationList" :class="{'active':item.conversation_id==conversationID}" @click="selectedConversation(item)">
        <div class="icon">
          <el-badge :value="item.unread" :hidden="item.unread==0" class="item">
            <img class="avatar" alt="img" :src="iconUrl(item.headImage)" />
          </el-badge>
        </div>
        <div class="detail">
          <div class="info">
            <p class="name">{{item.name}}</p>
            <p class="time">{{messageTime(item.latestMsgTimeStamp)}}</p>
          </div>
          <p class="msg">{{item.latestMsgStr}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import {mapState,mapGetters,mapActions} from 'vuex';
  import {allUsers} from '@/common/im/api';
  import {parseMessageTime} from '@/common/im/parse-time'
  import {socket} from '@/common/im/socket'
  export default {
    data () {
      return {
        imgprefix: (() => loadLocal('imgprefix', false))(),
      }
    },
    methods: {
      iconUrl(url){
        if (url === '' || !url) {
          return require('./userhead.png');
        } else {
          return this.imgprefix + url;
        }
      },
      messageTime(time) {
      	return time ? parseMessageTime(time) : '';
      },
      selectedConversation(item) {
        this.selectConversation(item.conversation_id);
      },
      exit() {

      },
      ...mapActions([
        'selectConversation'
      ])
    },
    computed:{
      //这里的三点叫做 : 扩展运算符
      ...mapState({
        userID:state=>state.conversation.currentUserID,
        userInfo:state=>state.conversation.userInfo,
        conversationID:state=>state.conversation.conversationID,
        conversationList:state=>state.conversation.conversationList,
      }),
    },
    created(){

    },
    components: {

    }
  }
</script>

<style scoped lang="scss">
  .panel {
    .header {
      padding: 18px;
      position: relative;
      .avatar {
        display: table-cell;
        padding-right: 10px;
        img {
          width: 40px;
          height: 40px;
          border-radius: 2px;
          display: block;
          cursor: pointer;
        }
      }
      .info {
        display: table-cell;
        width: 160px;
        word-break: break-all;
        word-wrap: break-word;
        vertical-align: middle;
        .nickName {
          text-align: left;
          span {
            display: inline-block;
            width: 140px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            word-wrap: normal;
            color: #fff;
            font-size: 18px;
            vertical-align: top;
            line-height: 30px;
            text-decoration: none;
          }
        }
      }
      .exit {
        display: table-cell;
        vertical-align: middle;
        color: #fff;
        cursor: pointer;
      }
    }
    .chat_list {
      overflow: hidden;
      .chat_item {
        height: 64px;
        padding: 12px 18px;
        cursor: pointer;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #292c33;
        box-sizing: border-box;
        .icon {
          position: relative;
          float: left;
          margin-right: 10px;
          .item {
            margin-top: 10px;
            margin-right: 10px;
          }
          .avatar {
            width: 40px;
            height: 40px;
            border-radius: 2px;
          }
        }
        .detail {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 40px;
          overflow: hidden;
          p {
            height: 20px;
            line-height: 20px;
            font-size: 12px;
            color: #989898;
            text-align: left;
            margin: 0;
          }
          .info {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .name {
              color: white;
            }
          }
        }
        &.active {
          background: #3a3f45;
          .time, .msg {
            color: white;
          }
        }
      }
    }
  }
</style>

<style lang="scss">
  #panel {
    .el-badge {
      .el-badge__content  {
        border: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/chat/components/panel.vue